export const TRANSFER_ROUTE_PATHS = {
  transfers: '/movements/tp/transfers',
  batch: '/movements/tp/transfers/batch',
};

export const TRANSFER_API_PATHS = {
  transfers: '/v1/api/platform/transfer-platform/transfers',
  cbuReversal: '/v1/api/platform/transfer-platform/transfers/cbu/reverse',
  cbuCredit: '/v1/api/platform/transfer-platform/transfers/cbu/credit',
  refund: (id: number) => `/v1/api/platform/transfer-platform/transfers/${id}/refund`,
  cvuCredit: (id: number) => `/v1/api/platform/transfer-platform/transfers/${id}/credit`,
  transferStatus: (id: number) => `/v1/api/platform/transfer-platform/transfers/${id}/status`,
  reprocess: (id: number) => `/v1/api/platform/transfer-platform/transfers/${id}/reprocess`,
  batchReprocess: '/v1/api/platform/transfer-platform/transfers/reprocess/batch',
  batchCancel: '/v1/api/platform/transfer-platform/transfers/cancel/batch',
};

export const TransferStatus = {
  ResolutionCompleted: 1,
  FraudCheck: 2,
  FraudDenied: 3,
  WalletDebitPending: 4,
  WalletDebited: 5,
  WalletDebitFailed: 6,
  ProviderPending: 7,
  ProviderSubmitted: 8,
  ProviderSubmissionUnknown: 9,
  ProviderAccepted: 10,
  ProviderRejected: 11,
  ProviderFailed: 12,
  ReversalPending: 13,
  Reversed: 14,
  ReversalFailed: 15,
  Completed: 16,
  UnderReview: 17,
  WalletCreditPending: 18,
  WalletCreditFailed: 19,
  ResolutionPending: 20,
  ResolutionFailed: 21,
  RequestCheck: 22,
  RequestInvalid: 23,
  AliasCheck: 24,
  AliasNotFound: 25,
  FraudCheckFailed: 26,
  ReviewApproved: 30,
  ReviewRejected: 31,
  ReturnInProgress: 32,
  ReturnCompleted: 33,
  ReturnFailed: 34,
  Created: 35,
  ManualInterventionRequired: 36,
  TmDebitPending: 37,
  TmDebitCompleted: 38,
  TmDebitFailed: 39,
  WalletCredited: 40,
  Failed: 41,
  Refunded: 42,
  ManualCancellationRequested: 49,
  ManualRetryRequested: 50,
};

export const TRANSFER_STATUS_MANUAL_INTERVENTION = TransferStatus.ManualInterventionRequired;

export const TRANSFER_STATUS_MANUAL_RETRY_REQUESTED = TransferStatus.ManualRetryRequested;

export const STUCK_TRANSFER_STATUS_IDS = [
  TransferStatus.FraudCheck,
  TransferStatus.WalletDebitFailed,
  TransferStatus.WalletCreditFailed,
  TransferStatus.AliasCheck,
  TransferStatus.FraudCheckFailed,
];

export const CBU_RAIL_ID = 3;

export const CVU_RAIL_ID = 4;

export const CLOSED_LOOP_TRANSFER_RAIL_ID = 5;

export const IBAN_RAIL_ID = 6;

export const RAIL_LABELS: Record<number, string> = {
  [CBU_RAIL_ID]: 'CBU',
  [CVU_RAIL_ID]: 'CVU',
  [CLOSED_LOOP_TRANSFER_RAIL_ID]: 'Closed Loop',
  [IBAN_RAIL_ID]: 'IBAN',
};

export const INFINITE_LEVEL_ID = 5;

export const DEFAULT_SUBJECT_TYPE_ID = 1;

export const SUBJECT_TYPE_OPTIONS = [
  { label: 'User', value: 1 },
  { label: 'Business', value: 2 },
  { label: 'Operational', value: 3 },
];

export const TRANSFER_STATUS_OPTIONS = [
  { label: 'Resolution Completed', value: TransferStatus.ResolutionCompleted },
  { label: 'Fraud Check', value: TransferStatus.FraudCheck },
  { label: 'Fraud Denied', value: TransferStatus.FraudDenied },
  { label: 'Wallet Debit Pending', value: TransferStatus.WalletDebitPending },
  { label: 'Wallet Debited', value: TransferStatus.WalletDebited },
  { label: 'Wallet Debit Failed', value: TransferStatus.WalletDebitFailed },
  { label: 'Provider Pending', value: TransferStatus.ProviderPending },
  { label: 'Provider Submitted', value: TransferStatus.ProviderSubmitted },
  { label: 'Provider Submission Unknown', value: TransferStatus.ProviderSubmissionUnknown },
  { label: 'Provider Accepted', value: TransferStatus.ProviderAccepted },
  { label: 'Provider Rejected', value: TransferStatus.ProviderRejected },
  { label: 'Provider Failed', value: TransferStatus.ProviderFailed },
  { label: 'Reversal Pending', value: TransferStatus.ReversalPending },
  { label: 'Reversed', value: TransferStatus.Reversed },
  { label: 'Reversal Failed', value: TransferStatus.ReversalFailed },
  { label: 'Completed', value: TransferStatus.Completed },
  { label: 'Under Review', value: TransferStatus.UnderReview },
  { label: 'Wallet Credit Pending', value: TransferStatus.WalletCreditPending },
  { label: 'Wallet Credit Failed', value: TransferStatus.WalletCreditFailed },
  { label: 'Resolution Pending', value: TransferStatus.ResolutionPending },
  { label: 'Resolution Failed', value: TransferStatus.ResolutionFailed },
  { label: 'Request Check', value: TransferStatus.RequestCheck },
  { label: 'Request Invalid', value: TransferStatus.RequestInvalid },
  { label: 'Alias Check', value: TransferStatus.AliasCheck },
  { label: 'Alias Not Found', value: TransferStatus.AliasNotFound },
  { label: 'Fraud Check Failed', value: TransferStatus.FraudCheckFailed },
  { label: 'Review Approved', value: TransferStatus.ReviewApproved },
  { label: 'Review Rejected', value: TransferStatus.ReviewRejected },
  { label: 'Return In Progress', value: TransferStatus.ReturnInProgress },
  { label: 'Return Completed', value: TransferStatus.ReturnCompleted },
  { label: 'Return Failed', value: TransferStatus.ReturnFailed },
  { label: 'Created', value: TransferStatus.Created },
  { label: 'Manual Intervention Required', value: TransferStatus.ManualInterventionRequired },
  { label: 'TM Debit Pending', value: TransferStatus.TmDebitPending },
  { label: 'TM Debit Completed', value: TransferStatus.TmDebitCompleted },
  { label: 'TM Debit Failed', value: TransferStatus.TmDebitFailed },
  { label: 'Wallet Credited', value: TransferStatus.WalletCredited },
  { label: 'Failed', value: TransferStatus.Failed },
  { label: 'Refunded', value: TransferStatus.Refunded },
  { label: 'Manual Cancellation Requested', value: TransferStatus.ManualCancellationRequested },
  { label: 'Manual Retry Requested', value: TransferStatus.ManualRetryRequested },
];

export const TransferType = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
} as const;

export type TransferType = (typeof TransferType)[keyof typeof TransferType];
